import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Command Center launcher (spec 11.5): ask from any screen. It does NOT answer in a popover — it
// hands the question to the dedicated /ask surface (room for the answer cards + the query log), so
// the answer renders with provenance and deep links instead of cramped in the topbar. /ask is the
// only place an answer is shown; this is just the entry point.
export default function AskBar() {
  const navigate = useNavigate();
  const [question, setQuestion] = useState('');

  function submit() {
    const q = question.trim();
    if (!q) return;
    // Nonce so re-asking the same question re-runs on /ask (and so strict-mode effects dedupe).
    navigate(`/ask?q=${encodeURIComponent(q)}&t=${Date.now()}`);
    setQuestion('');
  }

  return (
    <input
      className="c2-input"
      style={{ width: 320, height: 34 }}
      placeholder="Ask the system…"
      value={question}
      onChange={(e) => setQuestion(e.target.value)}
      onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
      aria-label="Ask the system"
    />
  );
}
